import React, { useEffect, useRef, useState } from 'react';
import { ChevronDownIcon, MenuIcon, PhoneIcon, MapPinIcon, ShoppingCartIcon, XIcon } from 'lucide-react';
import { CATEGORIES, CONTACT, IMAGES, LINKS, SECONDARY_CATALOG_LINKS } from '../data/site';
import { CatalogSearch } from './CatalogSearch';
const NAV = [{
  name: 'Workshops',
  href: LINKS.workshops
}, {
  name: 'Custom Fabrication',
  href: LINKS.fabrication
}, {
  name: 'Our Story',
  href: LINKS.story
}, {
  name: 'Contact',
  href: LINKS.contact
}];
const SHOP_MENU = [{
  name: 'Shop All Tools',
  href: LINKS.shopAll
}, ...CATEGORIES.map(c => ({
  name: c.name,
  href: c.href
})), {
  name: 'ECKOLD Machines',
  href: LINKS.eckold
}, ...SECONDARY_CATALOG_LINKS];
export function Header() {
  const [shopOpen, setShopOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const shopWrapRef = useRef<HTMLDivElement>(null);
  const shopButtonRef = useRef<HTMLButtonElement>(null);
  const mobileButtonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!shopOpen && !mobileOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        if (mobileOpen) mobileButtonRef.current?.focus();else shopButtonRef.current?.focus();
        setShopOpen(false);
        setMobileOpen(false);
      }
    };
    const onClick = (e: MouseEvent) => {
      if (shopWrapRef.current && !shopWrapRef.current.contains(e.target as Node)) setShopOpen(false);
    };
    document.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onClick);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onClick);
    };
  }, [shopOpen, mobileOpen]);
  return <header className="relative z-40 bg-cream" data-id="element-152" data-mp="30lwpjlvyyfdj">
      <div className="bg-charcoal text-steel-200" data-id="element-153" data-mp="1w60h2t429sp">
        <div className="mx-auto flex max-w-[1240px] flex-wrap items-center justify-between gap-x-4 gap-y-1 px-5 py-2 text-[12px] sm:px-8 sm:text-[13px]" data-id="element-154" data-mp="1y0l0g0gzzw9">
          <p className="leading-snug" data-id="element-155" data-mp="1rd1juutuyjiu">Metal Shaping Tools, Workshops &amp; Custom Fabrication</p>
          <div className="flex w-full items-center justify-between gap-5 text-[11px] sm:w-auto sm:text-[13px]" data-id="element-156" data-mp="1wd61io6i5kan">
            <p className="flex items-center gap-2" data-id="element-157" data-mp="1hojm6mgvksjf">
              <MapPinIcon aria-hidden="true" className="h-3.5 w-3.5 text-fred" data-id="element-158" data-mp="1hlnmaslgvtsc" />
              <span data-id="element-159" data-mp="1ml0b3ivwfaxk">Mt. Clemens, Michigan</span>
            </p>
            <a href={CONTACT.phoneHref} className="flex items-center gap-2 font-medium text-white transition-colors hover:text-fred" data-id="element-160" data-mp="18mtvjiuthxmp">
              <PhoneIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-161" data-mp="1cq008m2a7gr2" />
              <span data-id="element-162" data-mp="ypxm9ax3h7h3">{CONTACT.phoneLabel}</span>
            </a>
          </div>
        </div>
      </div>
      <div className="border-b border-steel-200" data-id="element-163" data-mp="13p1u9y8a8z5u">
        <div className="mx-auto flex h-[84px] max-w-[1240px] items-center justify-between gap-3 px-5 sm:h-[92px] sm:gap-6 sm:px-8 lg:gap-8" data-id="element-164" data-mp="13ptph7xywuvl">
          <a href="/" className="flex shrink-0 items-center" aria-label="Fournier Enterprises home" data-id="element-165" data-mp="2y29q9t7zvgt2">
            <img src={IMAGES.headerLogo} width={394} height={252} alt="Fournier Enterprises" className="h-[80px] w-auto object-contain mix-blend-multiply sm:h-[88px]" data-id="element-166" data-mp="mfptg98azukk" />
          </a>
          <div className="hidden min-w-0 flex-1 flex-col lg:flex" data-id="element-167" data-mp="w4pxi71nxg5m">
            <CatalogSearch data-id="element-168" data-mp="rdrdawdjzxx3" />
            <nav aria-label="Primary" className="flex items-center justify-between gap-3" data-id="element-169" data-mp="rdhhut9qoyk0">
              <div ref={shopWrapRef} className="relative" data-id="element-170" data-mp="154cxcoequdwk">
                <button type="button" ref={shopButtonRef} aria-controls="shop-menu" aria-expanded={shopOpen} onClick={() => setShopOpen(v => !v)} className="flex min-h-[44px] items-center gap-1.5 whitespace-nowrap font-display text-[17px] font-semibold uppercase tracking-[0.04em] text-fred xl:text-[19px]" data-id="element-171" data-mp="156z4imxq2re9">
                  Shop Tools
                  <ChevronDownIcon aria-hidden="true" className={`h-4 w-4 transition-transform ${shopOpen ? 'rotate-180' : ''}`} data-id="element-172" data-mp="3gv8flb2499bp" />
                </button>
                {shopOpen && <div id="shop-menu" className="absolute left-0 top-full z-50 w-[480px] border border-steel-200 bg-white p-3 shadow-lg" data-id="element-173" data-mp="22xvrcfnnf5q4">
                    <ul className="grid grid-cols-2" data-id="element-174" data-mp="27zl5i4663zif">
                      {SHOP_MENU.map(item => <li key={item.name} data-id="element-175" data-mp="2gyg8z8htuvi1">
                          <a href={item.href} className="flex min-h-[44px] items-center px-3 py-2 text-[14px] text-ink transition-colors hover:bg-cream hover:text-fred" data-id="element-176" data-mp="2gx57jfbutzu3">
                            {item.name}
                          </a>
                        </li>)}
                    </ul>
                  </div>}
              </div>
              <a href={LINKS.specials} className="flex min-h-[44px] items-center whitespace-nowrap font-display text-[17px] uppercase tracking-[0.04em] text-charcoal hover:text-fred xl:text-[19px]" data-id="element-177" data-mp="1y0425tee1xpm">Sales &amp; Specials</a>
              {NAV.map(item => <a key={item.name} href={item.href} className="flex min-h-[44px] items-center whitespace-nowrap font-display text-[17px] uppercase tracking-[0.04em] text-charcoal transition-colors hover:text-fred xl:text-[19px]" data-id="element-178" data-mp="15h6r2qeckbiu">
                  {item.name}
                </a>)}
            </nav>
          </div>
          <div className="flex shrink-0 items-center gap-3" data-id="element-179" data-mp="k097cj9ego2z">
            <a href={LINKS.cart} aria-label="Shopping cart" className="flex min-h-[44px] items-center justify-center gap-2 bg-fred px-3 font-display text-[18px] uppercase tracking-[0.06em] text-white transition-colors hover:bg-fred-dark sm:px-5" data-id="element-180" data-mp="jzpn2vwa1nls">
              <ShoppingCartIcon aria-hidden="true" className="h-5 w-5" data-id="element-181" data-mp="5c4pfhi68gl9" />
              Cart
            </a>
            <button type="button" onClick={() => setMobileOpen(v => !v)} ref={mobileButtonRef} aria-expanded={mobileOpen} aria-controls="mobile-menu" className="flex h-11 w-11 shrink-0 items-center justify-center border border-steel-200 text-charcoal lg:hidden" data-id="element-182" data-mp="1asvizs9l979">
              <span className="sr-only" data-id="element-183" data-mp="3ds2c081yx6ax">{mobileOpen ? 'Close menu' : 'Open menu'}</span>
              {mobileOpen ? <XIcon aria-hidden="true" className="h-5 w-5" data-id="element-184" data-mp="3it8akmib7nsd" /> : <MenuIcon aria-hidden="true" className="h-5 w-5" data-id="element-185" data-mp="3ipu7fc1tnajv" />}
            </button>
          </div>
        </div>
        <div className="mx-auto max-w-[1240px] px-5 pb-3 sm:px-8 lg:hidden" data-id="element-186" data-mp="38tr1rw7rgts6">
          <CatalogSearch data-id="element-187" data-mp="38vu33ced69c7" />
        </div>
      </div>
      {mobileOpen && <div id="mobile-menu" className="border-b border-steel-200 bg-white lg:hidden" data-id="element-188" data-mp="ezaqqv707cd">
          <nav aria-label="Mobile" className="mx-auto max-w-[1240px] px-5 py-4 sm:px-8" data-id="element-189" data-mp="5cr1hhk3pnez">
            <a href={LINKS.shopAll} className="mb-4 flex min-h-[48px] items-center justify-center bg-fred px-5 font-display text-[20px] uppercase tracking-[0.07em] text-white" data-id="element-190" data-mp="3mt0j4z7pdtxq">Shop All Tools</a>
            <p className="mb-2 font-display text-[13px] uppercase tracking-eyebrow text-steel-600" data-id="element-191" data-mp="jc0fcaku45fs">Shop by category</p>
            <ul className="mb-4 border-t border-steel-100" data-id="element-192" data-mp="o5cs9ng5insp">
              {SHOP_MENU.slice(1).map(item => <li key={item.name} className="border-b border-steel-100" data-id="element-193" data-mp="28s44ow7muphr">
                  <a href={item.href} className="flex min-h-[48px] items-center text-[15px] text-ink" data-id="element-194" data-mp="23ub0g8pw45k4">{item.name}</a>
                </li>)}
            </ul>
            <ul className="border-t border-steel-100" data-id="element-195" data-mp="2dkdt27t3nhhx">
              {NAV.map(item => <li key={item.name} className="border-b border-steel-100" data-id="element-196" data-mp="1put5tcpwxy2u">
                  <a href={item.href} className="flex min-h-[48px] items-center font-display text-[20px] uppercase tracking-[0.04em] text-charcoal" data-id="element-197" data-mp="1px5us9u398pe">{item.name}</a>
                </li>)}
            </ul>
            <a href={CONTACT.phoneHref} className="mt-4 flex min-h-[48px] items-center gap-2 font-medium text-charcoal" data-id="element-198" data-mp="1uunvjcxychmb">
              <PhoneIcon aria-hidden="true" className="h-4 w-4 text-fred" data-id="element-199" data-mp="3aaenong5gs75" />{CONTACT.phoneLabel}
            </a>
          </nav>
        </div>}
    </header>;
}